export const WALLET_SUMMARY = {
  availableCents: 50_000_00,
  pendingCents: 20_000_00,
  settledCents: 120_500_00,
};

function formatMoney(cents) {
  const n = cents / 100;
  return `$${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatWalletAmount(cents) {
  return formatMoney(cents);
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"];

export function buildPayoutHistoryMock(total = 42) {
  return Array.from({ length: total }, (_, i) => {
    const d = 1 + (i % 28);
    const m = MONTHS[i % MONTHS.length];
    const y = 2026;
    return {
      id: String(i + 1),
      dateLabel: `${d} ${m}, ${y}`,
      reference: `TRN-102-${String(23 + i).padStart(2, "0")}`,
      amountCents: (100 + i * 75) * 100,
      methodLabel: "Bank Transfer — Access Bank ****1234",
    };
  });
}

export const PAYOUT_HISTORY_MOCK = buildPayoutHistoryMock(42);
